import { RemindersOverview, RemindersTrendPoint, ReminderTrackerItem } from '@app/core/api/reminders-analytics';

export interface RemindersAnalyticsState {
  overview: RemindersOverview | null;
  trend: RemindersTrendPoint[];
  tracker: ReminderTrackerItem[];
  loading: boolean;
  error: string | null;
}

export const initialRemindersAnalyticsState: RemindersAnalyticsState = {
  overview: null,
  trend: [],
  tracker: [],
  loading: false,
  error: null
};
